module.exports = __webpack_public_path__ + "static/media/downloadLink.712cec8c.mp3";